import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useLocations } from '../../States/Location/Location';
import useLocationStore from '../store/locationStore';

const ChooseLocModal = ({ isChooseLocModalOpen, setIsChooseLocModalOpen }) => {
    const { getAllProvinses, getAllCities } = useLocations((state) => state.actions);
    const provinses = useLocations((state) => state.provinses);
    const cities = useLocations((state) => state.cities); // assuming `cities` is stored in the state
    const provinceCode = useLocationStore((state) => state.provinceCode);
    const cityCode = useLocationStore((state) => state.cityCode);

    const { setProvinceCode, setCityCode } = useLocationStore();
    console.log(provinceCode, "provinceCode in ChooseModal");

    const [searchTerm, setSearchTerm] = useState('');
    const [provinceName, setProvinceName] = useState('');
    const [viewMode, setViewMode] = useState('province'); // 'province' or 'city'


    useEffect(() => {
        getAllProvinses(1);
    }, []);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleProvinceClick = (prov) => {
        setProvinceCode(prov.id);
        getAllCities(prov.id);
        setViewMode('city');
        setSearchTerm(''); // reset search
        setProvinceName(prov.locName)
    };

    const handleCityClick = (city) => {
        setCityCode(city.id);
        setIsChooseLocModalOpen(false);
        console.log('Selected city:', city);
    };

    const filteredList = viewMode === 'province'
        ? provinses?.filter((prov) =>
            prov.locName?.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : cities?.filter((city) =>
            city.locName?.toLowerCase().includes(searchTerm.toLowerCase())
        );

    return (
        <Modal
            title={viewMode === 'province' ? 'انتخاب استان' :
                <div className="text-base">
                    <span className="font-bold">انتخاب شهر   </span> <span className="text-gray-600 dark:text-[#B9B9B9]"> استان <span >{provinceName}</span> </span>
                </div>
            }
            open={isChooseLocModalOpen}
            onCancel={() => {
                setIsChooseLocModalOpen(false);
                setViewMode('province'); // reset on close
                setSearchTerm('');
            }}
            footer={null}
            className='chooseLoc '
        >
            {viewMode === 'city' && (
                <button
                    className="mb-3 text-blue-600 hover:underline transition duration-200"
                    onClick={() => {
                        setViewMode('province');
                        setSearchTerm('');
                    }}
                >
                    <div className='text-[#747474] flex dark:text-[#B9B9B9]'>   <img src='/icons/arrow-right-modal.svg' alt='' /> بازگشت به انتخاب استان</div>

                </button>
            )}
            <input
                placeholder="جست و جو"
                value={searchTerm}
                onChange={handleSearch}
                className="w-full p-2 border  mb-4 bg-[#F4F4F4] text-[#747474] rounded-lg dark:bg-[#414141] dark:!outline-black dark:!border-none "
            />
            <div
                className="transition-all duration-400 ease-in-out max-h-64 overflow-y-auto"
                key={viewMode} // forces re-transition on view change
            >
                <ul className="max-h-64 overflow-y-auto">
                    {filteredList?.map((item) => (
                        <li
                            key={item.id}
                            className={`p-2 hover:bg-gray-100 cursor-pointer rounded ${(provinceCode == item.id || cityCode == item.id) ? `bg-blue-200 dark:bg-[#2c2c2c]` : ``}`}
                            onClick={() =>
                                viewMode === 'province' ? handleProvinceClick(item) : handleCityClick(item)
                            }
                        >
                            {item.locName}
                        </li>
                    ))}
                    {filteredList?.length === 0 && <li className="text-gray-500">موردی یافت نشد</li>}
                </ul>
            </div>
        </Modal>
    );
};

export default ChooseLocModal;
